(() => {
  const bar = document.querySelector('[data-ff-mobile-buy]');
  if (!bar) return;
  const mobile = window.matchMedia('(max-width: 800px)');
  const form = document.querySelector('#MainContent form.product-form');
  const mainButton = form && form.querySelector('button[type="submit"]');
  const button = bar.querySelector('[data-ff-buy-button]');
  const price = bar.querySelector('[data-ff-buy-price]');
  let variants;
  try { variants = JSON.parse(bar.querySelector('[data-ff-buy-variants]').textContent); } catch (_) { return; }
  let queued = false;
  function syncVariant() {
    if (!button || !form) return;
    const field = form.querySelector('[name="id"]');
    const variant = variants.find(v => String(v.id) === (field && field.value));
    button.disabled = !variant || !variant.available;
    button.textContent = variant && variant.available ? 'Add to basket' : 'Sold out';
    if (variant) price.textContent = variant.price;
  }
  function update() {
    queued = false;
    const active = document.activeElement;
    const typing = active && (active.matches('input,textarea,select') || active.isContentEditable);
    const blocked = document.body.classList.contains('paw-popup-open') || document.body.classList.contains('paw-menu-open') || typing;
    const rect = mainButton && mainButton.getBoundingClientRect();
    const mainVisible = rect && rect.top < window.innerHeight && rect.bottom > 0 && mainButton.getClientRects().length > 0;
    const allowed = bar.dataset.navigationOnly === 'true' || !!mainButton;
    const show = mobile.matches && allowed && window.scrollY > Math.max(280, window.innerHeight * .55) && !mainVisible && !blocked;
    bar.hidden = false;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', String(!show));
    bar.inert = !show;
    // Reserve space after scrolling so the final page content stays reachable.
    const reserve = mobile.matches && allowed && window.scrollY > 200;
    if (document.body.classList.contains('ff-buy-space') !== reserve) document.body.classList.toggle('ff-buy-space', reserve);
    syncVariant();
  }
  function schedule() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  document.addEventListener('focusin',schedule);
  document.addEventListener('focusout',schedule);
  if (form) form.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(document.body,{attributes:true,attributeFilter:['class']});
  if (button && form) button.addEventListener('click', () => {
    syncVariant();
    if (button.disabled) return;
    // Use the original Shopify form, including its chosen variant and quantity.
    if (form.requestSubmit) form.requestSubmit(mainButton);
    else mainButton.click();
  });
  update();
})();
